import { TABLE_CHIP_BASE, TABLE_CHIP_TONES } from './TableChip';

/**
 * Compact status chip — shared shape with dashboard table chips.
 */
export function StatusBadge({
  children,
  tone = 'neutral',
  className = '',
  ...props
}) {
  return (
    <span
      className={`${TABLE_CHIP_BASE} ${TABLE_CHIP_TONES[tone] || TABLE_CHIP_TONES.neutral} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
